import { useMutation, UseMutationResult } from 'react-query';
import { createPaymentLink, CreatePaymentLinkParams } from '../api/paymentsApi';

export const useCreatePaymentLinkMutation = ():
  UseMutationResult<PaymentLink, unknown, CreatePaymentLinkParams, unknown> => {
  return useMutation(
    async (params: CreatePaymentLinkParams) => createPaymentLink(params),
  );
};
